import { useContext } from "react";
import { AppContext } from "../App";
import { services } from "./ServicesContent";

export default function ServiceDetailContent({ serviceSlug }) {
  const appContext = useContext(AppContext);
  const service = services.find((item) => item.slug === serviceSlug);

  if (!service) {
    return (
      <section className="section-shell">
        <div className="container">
          <div className="editorial-panel text-center">
            <h2>Service not found</h2>
            <p>The service you requested is not available in the current profile.</p>
            <button
              className="btn btn-primary"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              Back to Services
            </button>
          </div>
        </div>
      </section>
    );
  }

  const relatedServices = services.filter((item) => item.slug !== serviceSlug).slice(0, 3);

  return (
    <>
      <section className="page-hero service-detail-hero" style={{backgroundImage: `url(${service.image})`, backgroundSize: 'cover', backgroundPosition: 'center', width: "100%", height: "100%", objectFit: "cover"}}>
        <div className="service-detail-hero-overlay" />
        <div className="container" >
          <div className="page-hero-content service-detail-copy" >
          
            <button
              className="btn btn-outline-light mb-4"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              Back to Services
            </button>
            <h1 data-aos="fade-right" data-aos-delay="100">{service.title}</h1>
            <p data-aos="fade-up" data-aos-delay="200">{service.shortDescription}</p>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7">
              <div className="editorial-panel h-100">
                <h2 data-aos="fade-right" data-aos-delay="100">Overview</h2>
                <p data-aos="fade-up" data-aos-delay="200">{service.description}</p>
                <div className="feature-image-card mt-4" data-aos="fade-up" data-aos-delay="300">
                  <img src={service.image} alt={service.title} />
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="vision-panel h-100" data-aos="fade-up" data-aos-delay="100">
                <h3>Includes</h3>
                <div className="bullet-grid">
                  {service.features.map((feature) => (
                    <div key={feature} className="bullet-grid-item">
                      <span />
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
                <div className="detail-highlight-box">
                  <strong>Why it matters</strong>
                  <p>{service.highlight}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-soft">
        <div className="container">
          <div className="section-heading-row">
            <div data-aos="fade-right" data-aos-delay="100">
              <h2>Related services</h2>
              <p>Other ways we support customers through the MS Universal portfolio.</p>
            </div>
          </div>

          <div className="row g-4">
            {relatedServices.map((item) => (
              <div key={item.slug} className="col-md-6 col-xl-4" data-aos="fade-up" data-aos-delay="200">
                <button
                  className="service-card text-start h-100 w-100"
                  onClick={() =>
                    appContext.navTo({ item: "services", subItem: item.slug })
                  }
                >
                  <img src={item.image} alt={item.title} className="service-card-image" />
                  <div className="service-card-body">
                    <h3>{item.title}</h3>
                    <p>{item.shortDescription}</p>
                    <span className="service-card-link">Explore Service</span>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
